export const processDateArithmetic = (value: string): string => {
  const dateArithmeticRegex = /(\d{4}-\d{2}-\d{2})([+-]\d+)([dwmy])/g;

  return value.replace(dateArithmeticRegex, (match, dateStr, operation, unit) => {
    try {
      const baseDate = new Date(dateStr);
      const amount = parseInt(operation);

      let resultDate = new Date(baseDate);

      switch (unit) {
        case 'd': // days
          resultDate.setDate(baseDate.getDate() + amount);
          break;
        case 'w': // weeks
          resultDate.setDate(baseDate.getDate() + amount * 7);
          break;
        case 'm': // months
          resultDate.setMonth(baseDate.getMonth() + amount);
          break;
        case 'y': // years
          resultDate.setFullYear(baseDate.getFullYear() + amount);
          break;
      }

      return resultDate.toISOString().split('T')[0];
    } catch (error) {
      console.warn('Error processing date arithmetic:', error);
      return match; // Return original if processing fails
    }
  });
};
